export default __webpack_public_path__ + "assets/images/e57c362352281bd9867ec45e6fbabbcc.webp";